app.service('$socket', ['$rootScope', '$timeout', function ($rootScope, $timeout) {

    return function (url, config) {

        var socket = io(url, config);

        function makeScopedCallback(callback) {
            return function () {
                var args = arguments;
                $rootScope.$apply(function () {
                    try {
                        callback.apply(socket, args);
                    } catch (e) {
                        console.error('Can not apply callback on emit ', e);
                    }
                });
            };
        }

        this.getInstance = function () {
            return socket;
        };

        this.connect = function () {
                $timeout(function () {
                    socket.connect();
                }, 0);
        };

        this.disconnect = function () {
                $timeout(function () {
                    socket.removeAllListeners();
                    socket.disconnect();
                }, 0);
        };

        this.on = function on(event, callback) {
                var handler = makeScopedCallback(callback);
                socket.on(event, handler);
                return handler;
        };

        this.off = function off(event, callback) {
                (typeof callback == 'function') ?
                    socket.removeListener(event, callback) :
                    socket.removeAllListeners(event);
        };

        this.emit = function emit(event, data, callback) {
                if (typeof callback == 'function') {
                    socket.emit(event, data, function () {
                        var args = arguments;
                        $rootScope.$apply(function () {
                            callback.apply(socket, args);
                        });
                    });
                }
                else {
                    socket.emit(event, data);
                }
        };

        this.removeListener = function (event, callback) {
            $timeout(function () {
                socket.removeListener(event, callback)
            }, 0)
        };

        this.removeAllListeners = function (event) {
                $timeout(function () {
                    socket.removeAllListeners(event);
                }, 0)
        };

        this.subscribers = function () {
                return socket._callbacks;
        };

        return this;
            }

}]);
